<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            Atualizar Senha do Quiosque
          </h4>
          <div class="row col-6">
            <div class="col-12">
              <base-input class="text-left" label="Senha Atual">
                <el-input
                  color="success"
                  placeholder="Digite a senha atual"
                  v-model="payload.senhaAtual"
                >
                </el-input>
              </base-input>
            </div>
            <div class="col-12">
              <base-input class="text-left" label="Senha Nova">
                <el-input
                  color="success"
                  placeholder="Digite a senha nova"
                  v-model="payload.senhaNova"
                >
                </el-input>
              </base-input>
            </div>
            <div class="col-12">
              <base-input class="text-left" label="Confirmar a Senha">
                <el-input
                  color="success"
                  placeholder="Confirme a senha"
                  v-model="payload.senhaNova2"
                >
                </el-input>
              </base-input>
            </div>
            <div class="col-12">
              <base-button
                :disabled="isLoading"
                type="success"
                class="animation-on-hover"
                @click="salvar()"
                >Enviar</base-button
              >
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
  },
  data() {
    return {
      payload: {
        senhaAtual: "",
        senhaNova: "",
        senhaNova2: "",
      },
      isLoading: false,
    };
  },
  methods: {
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    validarSenhaNova() {
      if (this.payload.senhaNova != this.payload.senhaNova2) {
        this.showSwal(
          "auto-close",
          "Erro",
          `As senhas não estão iguais`,
          "error",
        );
        return false;
      } else {
        return true;
      }
    },
    salvar() {
      if (this.validarSenhaNova()) {
        const th = this;
        let url = `/api/login/atualizarSenhaQuiosqueEmpresa`;
        const body = {
          cpf_cnpj: this.$cookies.get("cnpj"),
          senha: this.payload.senhaAtual,
          senhaNova: this.payload.senhaNova,
        };
        this.axios
          .post(url, body, {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          })
          .then((response) => {
            console.log(response.data);
            if (response.data.data.status) {
              th.isLoading = false;
              window.location.reload();
              th.showSwal(
                "auto-close",
                "Sucesso",
                `Sucesso ao atualizar senha!`,
                "success",
              );
            } else {
              th.showSwal(
                "auto-close",
                "Erro",
                response.data.data.err,
                "error",
              );
            }
          })
          .catch((err) => {
            console.log(err);
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              `Erro ao atualizar senha!`,
              "error",
            );
          });
      }
    },
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
